import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  Dialog,
  DialogBody,
  DialogHeader,
  IconButton,
  Typography
} from "@material-tailwind/react";
import {useState} from "react";
import "../../../style/datePicker.css"
import {BranchGrid} from "./branch_grid";
import {BsBoxArrowDownRight} from "react-icons/bs";
import {AgentDisplayDetails} from "./display_details";
import {AgentsForm} from "./form";

export function AgentsDialog({
                               agentId,
                               open,
                               setOpen,
                               setLastDataRefresh,
                               gridSelectedRow,
                               setGridSelectedRow,
                               lastDataRefresh,
                               confirmationComments
                             }) {
  const [show, setShow] = useState(2);

  const handleShow = (value) => {
    setShow(show === value ? 0 : value);
  }

  const handleOpen = () => setOpen(!open);

  return (
    <>
      <Dialog className="overflow-x-scroll z-10"
              size="lg"
              open={open} handler={handleOpen}
              animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
        <DialogHeader className="border-b justify-between">
          <Typography>بررسی‌اطلاعات‌مشاور</Typography>
          <div className="flex gap-4">
            <IconButton variant="text" className="rounded-full" onClick={handleOpen}>
              <i className="far fa-times-circle" style={{fontSize: "36px"}}/>
            </IconButton>
          </div>
        </DialogHeader>
        <DialogBody className="" style={{overflowY: 'auto', overflowX: 'auto', maxHeight: '80vh', minHeight: '80vh'}}>

          <Accordion open={show === 1}>
            <AccordionHeader
              className="flex flex-row justify-between px-2 border bg-blue-gray-50 rounded-t-2xl hover:bg-blue-50"
              onClick={() => handleShow(1)}>
              <Typography className="flex w-full font-bold text-lg">
                اطلاعات‌مشاور
              </Typography>
              <BsBoxArrowDownRight className="flex"/>
            </AccordionHeader>
            <AccordionBody>
              <AgentsForm
                agentId={agentId}
                setLastDataRefresh={setLastDataRefresh}
                confirmationComments={confirmationComments}/>
            </AccordionBody>
          </Accordion>

          <Accordion className="pt-4" open={show === 2}>
            <AccordionHeader
              className="flex flex-row justify-between px-2 border bg-blue-gray-50 rounded-t-2xl  hover:bg-blue-50"
              onClick={() => handleShow(2)}>
              <Typography className="flex w-full font-bold text-lg">
                گرایشات‌درخواست‌مشاور
              </Typography>
              <BsBoxArrowDownRight className="flex"/>
            </AccordionHeader>
            <AccordionBody>
              <BranchGrid
                agentId={agentId}
                lastDataRefresh={lastDataRefresh}
                setLastDataRefresh={setLastDataRefresh}
              />
            </AccordionBody>
          </Accordion>

          <Accordion className="pt-4" open={show === 3}>
            <AccordionHeader
              className="flex flex-row justify-between px-2 border bg-blue-gray-50 rounded-t-2xl  hover:bg-blue-50"
              onClick={() => handleShow(3)}>
              <Typography className="flex w-full font-bold text-lg">
                اطلاعات نمایشی
              </Typography>
              <BsBoxArrowDownRight className="flex"/>
            </AccordionHeader>
            <AccordionBody>
              <AgentDisplayDetails
                agent_Id={agentId}
                lastDataRefresh={lastDataRefresh}
                setLastDataRefresh={setLastDataRefresh}
              />
            </AccordionBody>
          </Accordion>

        </DialogBody>
      </Dialog>
    </>
  );
}